<template>
    <div class="member-rights">
        <van-swipe class="my-swipe" :loop="false" :show-indicators="false" :width="scrollWidth">
            <van-swipe-item v-for="(item, index) in levelList" :key="index">
                <div class="g-flex">
                    <div style="flex-grow: 1"><levelCard :data="item"></levelCard></div>
                    <div style="width: calc(var(--gap) * 10)" v-if="index < levelList.length - 1"></div>
                </div>
            </van-swipe-item>
        </van-swipe>
        <div>
            <div class="t" v-if="rightsData.ownEntitlementList.length > 0">已解锁{{ rightsData.ownEntitlementList.length }}项权益</div>
            <div class="t" v-else>会员权益</div>
            <div class="container">
                <div 
                class="a" 
                  :class="{ filter: !i.isOwn }" 
                  v-for="i in rightsData.allEntitlementList" 
                  :key="i.name"
                  @click="showDetail(i)">
                    <div class=""><van-image width="40" height="40" :src="i.icon" /></div>
                    <div class="a1 g-fs14 g-tc g-m-text-ellipsis">{{ i.name }}</div>
                </div>
            </div>
        </div>
        <van-action-sheet v-model="isShowDetail" :title="titleDetail">
            <div class="content">
                <div class="tit">权益对象</div>
                <div class="ri">{{ rightDetail }}</div>
                <div class="tit mt20">权益说明</div>
                <div v-html="contentDetail"></div>
            </div>
            <div class="btn"><van-button type="primary" block square round @click="closeBtn">知道了</van-button></div>
        </van-action-sheet>
    </div>
</template>

<script>
import levelCard  from './coms/level-card.vue'

export default {
  name: 'MemberRight',
  components: {
    levelCard
  },
  data () {
    return {
      pageTitle: '会员权益',
      userInfo: {},
      rightsData: {
        allEntitlementList: [],
        ownEntitlementList: [],
        levelList: []
      },
      isShowDetail: false,
      titleDetail: '',
      contentDetail: '',
      rightDetail: '',
      scrollWidth: 0
    }
  },
  computed: {      
    memberUseInfo () {
      return this.$store.state.memberUserInfos || {};
    },
    levelList () {
      let {rightsData, memberUseInfo } = this;
      let ret = rightsData.levelList
      if (memberUseInfo.id) {
          ret = rightsData.levelList.filter(item => item.level >= memberUseInfo.memberLevel)
      }
      return ret.map(item => {
          const next = ret.filter(el => el.level === item.level + 1)
          return {
              level: item.level,
              name: item.levelName,
              isCurrent: memberUseInfo.memberLevel === item.level,
              no: memberUseInfo.cardNo,
              nextPoint: item.score - memberUseInfo.totalPoint || 0,
              nextLevel: next.length > 0 ? next[0] : null,
              nextLevelPoint: next.length > 0 ? next[0].score - memberUseInfo.totalPoint : 0,
              levelBackgroundColor: item.backgroundColor || '',
              fontColor: item.fontColor || ''
          }
      })
    },
  },
  methods: {
    showDetail (item) {
      this.isShowDetail = true
      this.titleDetail = item.name
      this.contentDetail = item.description
      const temp = []
      item.entitlementObjects && item.entitlementObjects.forEach(el => {
          temp.push(el.levelName)
      })
      this.rightDetail = temp.join('、')
    },
    closeBtn () {
      this.isShowDetail = false;
    },
    handleResult (res) {
      this.rightsData.allEntitlementList = res.data.allEntitlementList || []
      this.rightsData.ownEntitlementList = res.data.ownEntitlementList || []
      this.rightsData.levelList = res.data.levelList || []
      this.rightsData.allEntitlementList.forEach(item => {
          const flag = this.rightsData.ownEntitlementList.filter(i => i.id === item.id)
          if (flag.length > 0) {
              item.isOwn = true
          } else {
              item.isOwn = false
          }
          if (!this.memberUseInfo.id) {
              item.isOwn = true
          }
      })
      this.rightsData.allEntitlementList.sort((a, b) => {
          return b.isOwn - a.isOwn
      })
    }
  },
  created () {
    if (this.memberUseInfo.id) {
        this.showLoading();
        this.$api.queryH5EntitlementList({memberId: this.memberUseInfo.id}).then(res => {
            this.$toast.clear();
            this.handleResult(res);
        })
    } else {
        this.$toast('请选择学员');
        this.$router.push('/member-stu-chooser');
    }
  },
  mounted () {
    this.scrollWidth = window.screen.width - 32 - 15
  }
}











</script>

<style lang="scss" scoped>
.g-flex {
    display: flex;
}
.g-m-text-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.member-rights {
    overflow: auto;
    padding: calc(var(--gap) * 16) calc(var(--gap) * 16) 0 calc(var(--gap) * 16);
    height: 100%;
    box-sizing: border-box;
    .t {
        font-size: calc(var(--gap) * 16);
        color: var(--g8);
        font-weight: 600;
        margin-top: calc(var(--gap) * 28);
    }
    .container {
        margin-top: calc(var(--gap) * 28);
        display: grid;
        grid-template-columns: repeat(4, 25%);
        .a {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-bottom: calc(var(--gap) * 20);
            .a1 {
                padding: 0 calc(var(--gap) * 10);
                word-break: break-all;
            }
        }
    }
    .content {
        padding: calc(var(--gap) * 16);
        .mt20 {
            margin-top: calc(var(--gap) * 20);
        }
        .tit {
            font-weight: var(--bold);
            padding-bottom: calc(var(--gap) * 5);
        }
        .ri {
            font-size:var(--fs-md);
            color: var(--g7);
        }
    }
    .btn {
        padding: calc(var(--gap) * 30) calc(var(--gap) * 16) calc(var(--gap) * 13);
    }
}
</style>

<style>
.filter {
    color: var(--g6);
}
.filter img {
    filter: grayscale(1);
    opacity: 0.3;
}
</style>
